<script>
import {useAssetTypesStore} from "@/stores/assetTypes.js";
import {mapStores} from "pinia";
import FilterCheckbox from "@/Forms/Filters/FilterCheckbox.vue";

export default {
  name: "FilterAssetTypesTab",
  inheritAttrs: false,
  components: {FilterCheckbox},
  computed: {
    ...mapStores(useAssetTypesStore),
  },
  mounted() {
    console.log(this.$options.name);
    this.assetTypesStore.indexAssetTypeOptions();
  },
}
</script>

<template>
  <p class="font-bold text-xl mb-4">{{ $t('forms.filters.edit_filters_form.headers.asset_types') }}</p>
  <div class="card flex flex-wrap justify-content-center gap-3">
    <FilterCheckbox
        v-for="assetType in assetTypesStore.getAssetTypeOptions"
        v-bind="$attrs"
        :value="assetType.id"
        :label="assetType.name"
    />
  </div>
</template>

<style scoped>

</style>
